import { addNamespace } from '@muz/jobboard-vue-client/src/store/helper/namespace';
import { merge } from 'lodash';
import LoaderTypes from './mixins/Loader';

const namespace = 'TitleAnalysis';

const Types = merge(
    {
        mutations: {
            SET_SCORE: 'setScore',
            SET_SUGGESTIONS: 'setSuggestions',
            RESET_SUGGESTIONS: 'resetSuggestions',
            SET_SUGGESTIONS_ERROR: 'setSuggestionsError',
            RESET_SUGGESTIONS_ERROR: 'resetSuggestionsError',
        },
        actions: {
            LOAD_SCORE: 'loadScore',
            LOAD_SUGGESTIONS: 'loadSuggestions',
            LOAD_CUSTOM_SUGGESTIONS: 'loadCustomSuggestions',
            SEND_FEEDBACK: 'sendFeedback',
        },
    },
    LoaderTypes,
);

export const LocalTypes = {
    ...Types,
    namespace,
};

export default {
    ...addNamespace(namespace, Types),
    namespace,
};
